/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'export': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M884.886 271.246a45.22 45.22 0 0116.454 16.89c13.93 17.62 12.8 43.262-3.42 59.584l-159 160c-17.52 17.628-46.012 17.718-63.64.2-17.628-17.52-17.718-46.012-.2-63.64L763.802 355H712c-85.604 0-155 69.396-155 155v134c0 24.852-20.148 45-45 45s-45-20.148-45-45V510c0-135.31 109.69-245 245-245h39.36l-77.18-77.18c-17.574-17.574-17.574-46.066 0-63.64 17.574-17.574 46.066-17.574 63.64 0l147.066 147.066zM753.546 673c-24.852 0-45-20.148-45-45s20.148-45 45-45H836c41.42 0 75 33.58 75 75v180c0 41.42-33.58 75-75 75H186c-41.42 0-75-33.58-75-75V658c0-41.42 33.58-75 75-75h80.276c24.852 0 45 20.148 45 45s-20.148 45-45 45H201v150h620V673h-67.454z"/>'
  }
})
